export enum ServiceOrderEvaluationStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED =  "COMPLETED",
}
